import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useCapabilities } from '../context/CapabilitiesContext';

const ModuleUnavailable = ({ title = 'Module unavailable' }) => {
  const navigate = useNavigate();

  return (
    <div className="consent-required-page">
      <div className="consent-required-container">
        <div className="consent-required-icon"><AlertTriangle size={32} /></div>
        <h2>{title}</h2>
        <p>This module is not available in this deployment.</p>
        <button
          className="consent-required-button"
          onClick={() => navigate('/home')}
        >
          Go to Home Page
        </button>
      </div>
    </div>
  );
};

const CapabilityError = () => (
  <div className="consent-required-page">
    <div className="consent-required-container">
      <div className="consent-required-icon"><AlertTriangle size={32} /></div>
      <h2>Configuration unavailable</h2>
      <p>Module availability could not be loaded. Please try again later.</p>
    </div>
  </div>
);

const ModuleAvailabilityRoute = ({ moduleKey, children }) => {
  const { loading, error, isModuleEnabled } = useCapabilities();

  if (loading) {
    return (
      <div className="consent-required-page">
        <div className="consent-required-container">
          <div className="loading-spinner">Loading module availability...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return <CapabilityError />;
  }

  if (!isModuleEnabled(moduleKey)) {
    return <ModuleUnavailable />;
  }

  return children;
};

export default ModuleAvailabilityRoute;
